import Vue from 'vue';
import campaignService from '../../services/api/Campaigns';
import { CAMPAIGNS_LOAD_ACTION, CAMPAIGN_BY_ID_ACTION, CAMPAIGN_CREATE_SUBMIT_ACTION, 
  CAMPAIGN_UPDATE_SUBMIT_ACTION, CAMPAIGN_SOURCETYPES_LOAD_ACTION, CAMPAIGN_STATUSES_LOAD_ACTION, CAMPAIGN_ARCHIVE_ACTION,
  CAMPAIGN_CALLPATH_UPDATE_ACTION, CAMPAIGN_CALLPATHS_LOAD_ACTION, CAMPAIGN_CLONE_CALLPATHS_LOAD_ACTION, CAMPAIGN_ENTITIES_LOAD_ACTION,
  CAMPAIGNS_BY_CALLPATHID_ACTION, CAMPAIGN_CALLTYPES_LOAD_ACTION, UPDATE_CAMPAIGN_CALLATTRIBUTES_STORE_DATA_ACTION,
  CAMPAIGN_AFFILIATETYPES_LOAD_ACTION, CAMPAIGN_GENERTATE_API_KEY_LOAD_ACTION, CAMPAIGN_DYNAMIC_REQUEST_LOAD_ACTION,
  CAMPAIGN_NAME_DIDS_LOAD_ACTION, CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_ACTION, CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_ACTION ,
  CAMPAIGN_LOAD_DROPDOWNS_ACTION, CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_ACTION, CAMPAIGN_UPDATE_SUPPRESSED_QUESTION_MAPPINGS_ACTION}  from '../action-types';
import {CAMPAIGNS_LOAD_MUTATION, CAMPAIGN_BY_ID_MUTATION, CAMPAIGN_CREATE_MUTATION, CAMPAIGN_UPDATE_MUTATION, 
    CAMPAIGN_SOURCETYPES_LOAD_MUTATION, CAMPAIGN_STATUSES_LOAD_MUTATION,CAMPAIGN_ARCHIVE_MUTATION, 
    CAMPAIGN_CALLPATH_UPDATE_MUTATION, CAMPAIGN_CALLPATHS_LOAD_MUTATION, CAMPAIGN_CALLPATH_MODIFIED_MUTATION, CAMPAIGN_STATUS_ACTIVE_MUTATION,
    CAMPAIGN_CLONE_CHANGE_MUTATION, CAMPAIGN_CHECK_CREATE_OR_UPDATE_MUTATION, CAMPAIGN_ENTITIES_LOAD_MUTATION,
    CAMPAIGN_CALLTYPES_LOAD_MUTATION, CAMPAIGN_AFFILIATETYPES_LOAD_MUTATION, 
    CAMPAIGN_FILTERTYPES_LOAD_MUTATION, CAMPAIGN_FILTERTYPES_CHANGED_MUTATION, CAMPAIGN_CALLATTRIBUTES_ADD_MUTATION, CAMPAIGN_CALLATTRIBUTES_REMOVE_MUTATION,
    CAMPAIGN_CALLATTRIBUTES_FILTERVALUE_CHANGED_MUTATION, CAMPAIGN_CALLATTRIBUTES_CLONE_MUTATION, CAMPAIGN_GENERTATE_API_KEY_LOAD_MUTATION,
    CAMPAIGN_DYNAMIC_REQUEST_CHANGED_MUTATION, CAMPAIGN_EXPIRY_TIME_CHANGED_MUTATION, CAMPAIGN_DETAILS_CLEAR_MUTATION,CAMPAIGN_OPERATORS_TYPES_CHANGED_MUTATION,
    CAMPAIGN_NAME_DIDS_LOAD_MUTATION, CAMPAIGN_BID_PRICE_CHANGED_MUTATION, CAMPAIGN_CREATE_TO_EDIT_MUTATION, CAMPAIGN_ASSIGN_CREATED_CALLPATH_DATA_MUTATION,
    CAMPAIGN_TO_CALLPATH_CREATE_MUTATION,CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_MUTATION, CAMPAIGN_CALL_ATTRIBUTE_SELECT_CHANNEL_NAME_FILTER_MUTATION, CAMPAIGN_CALL_ATTRIBUTE_REMOVE_CHANNEL_NAME_FILTER_MUTATION,
    CAMPAIGN_CALL_ATTRIBUTE_CLEAR_SELECTED_FILTER_NAME_LIST_MUTATION, CAMPAIGN_CALL_ATTRIBUTE_UPDATE_ISVALID_CAMPAIGN_FILTERTYPE_MUTATION, CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_MUTATION, CAMPAIGN_CALL_ATTRIBUTE_SELECT_CLIENT_NAME_FILTER_MUTATION,
    CAMPAIGN_CALL_ATTRIBUTE_REMOVE_CLIENT_NAME_FILTER_MUTATION, CAMPAIGN_DYNAMIC_REQUEST_OLD_DATA_MUTATION,
    CAMPAIGN_ASSIGN_CALLPATH_OLD_DATA_MUTATION, CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_MUTATION, CAMPAIGN_SUPPRESSED_QUESTION_CHANGED_MUTATION,
    CAMPAIGN_UPDATE_SUPPRESSED_QUESTIONS_MUTATION, ALL_CAMPAIGN_CALLPATH_LOAD_MUTATION, CLEAR_ASSIGN_CREATED_CALLPATH_MUTATION} from '../mutation-types';

import commonFunctions from '../../mixin/common-function-mixins';
import appConstants from '../../utility/app-constants';

// initial state
export const state = {
  namespaced: true,
  state: {
    campaignData: [],
    campaignStatusesData: [],
    campaignSourceTypesData: [],
    isClone:false,
    campaignCreate:0, //'1' for create & '2' for edit
    campaignCalltypesData: [],
    affiliateTypesData: [],
    campaignEntityData: []
  },
  campaignStateBidPriceData : [],
  campaignFilterType: [],
  dynamicRequest: 0,
  expiryTime: null,
  campaignDetails : null,
  campaignNameAndDidsData :[],
  isCampaignCreateToEdit: false,
  isCampaignCreateToCallPath: false,
  assignCallPathCampaignId : 0,
  assignCreatedCallPath : [],
  channelList: [],
  clientList: [],
  oldCampaignDetails:[],
  oldCampaignFilterType: [],
  oldDynamicRequest: 0,
  oldExpiryTime: null,
  concierge: [{ 'conciergeId': 1, 'conciergeName': 'true', 'conciergeValue': 'Yes' }, { 'conciergeId': 2, 'conciergeName': 'false', 'conciergeValue': 'No' }],
  oldCampaignCallPaths:[],
  suppressedQuestionMappings:[],
  suppressedQuestionData:null,
  isSuppressedQuestionsEnabled: false,
  oldSuppressedQuestion : null,
  selectedCampaignCallPath : [],
  allCampaignCallPaths : []
};

// actions
export const actions = {   
    async [CAMPAIGN_CREATE_SUBMIT_ACTION]({commit }, campaign) {
        const response = await campaignService.createCampaign(campaign);
        commit(CAMPAIGN_CREATE_MUTATION, response.data);
        return response;        
    },
    async [CAMPAIGN_UPDATE_SUBMIT_ACTION]({ commit }, campaign) {
        campaign.isConcierge = campaign.isConcierge.toString() == 'Yes' || campaign.isConcierge.toString() == 'true' ? true : false;
        const response = await campaignService.updateCampaign(campaign);
        commit(CAMPAIGN_UPDATE_MUTATION, response.data);
        return response;
    },
    async [CAMPAIGNS_LOAD_ACTION]({ commit }) {
        const response = await campaignService.getCampaigns();
        commit(CAMPAIGNS_LOAD_MUTATION, response.data);
        return response.data;
    },
    async [CAMPAIGN_BY_ID_ACTION]({commit}, campaignId) {
        const response = await campaignService.getCampaignsByID(campaignId);        
        commit(CAMPAIGN_BY_ID_MUTATION, response.data);
        return response.data;

    }, 
    async [CAMPAIGN_SOURCETYPES_LOAD_ACTION]({ commit }) {
      const response = await campaignService.getCampaignSourceTypes();
      commit(CAMPAIGN_SOURCETYPES_LOAD_MUTATION, response.data);
      return response.data;
    },   
    async [CAMPAIGN_STATUSES_LOAD_ACTION]({ commit }) {
        const response = await campaignService.getCampaignStatuses();
        commit(CAMPAIGN_STATUSES_LOAD_MUTATION, response.data);
        return response.data;
    }, 
    async [CAMPAIGN_ARCHIVE_ACTION]({ commit }, payLoad) {
      var requestData = { campaignId: payLoad.campaign.campaignId, partnerId: payLoad.campaign.partnerId , tazClientAuditLog: payLoad.tazClientAuditLog }
      const response = await campaignService.archiveCampaign(requestData);
      commit(CAMPAIGN_ARCHIVE_MUTATION, payLoad.campaign.campaignId);
      return response.data;
    },   
    async [CAMPAIGN_CALLPATHS_LOAD_ACTION]({ commit },  payLoad) {
        const response = await campaignService.getCampaignCallPaths(payLoad.campaignId);
        commit(CAMPAIGN_CALLPATHS_LOAD_MUTATION, {campaignCallPaths : response.data, payLoad:payLoad});
        return response;
    },   
    async [CAMPAIGN_CLONE_CALLPATHS_LOAD_ACTION]({ commit}, payLoad) {
        const response = await campaignService.getCampaignCallPaths(payLoad.cloneCampaignId);
        const mappedCallPaths = response.data.map((path) => {path.campaignId = payLoad.campaignId; path.campaignCallPathId = 0;  return path;});        
        commit(CAMPAIGN_CALLPATHS_LOAD_MUTATION, {campaignCallPaths : mappedCallPaths, payLoad: payLoad});
        return response;
    },   
    async [CAMPAIGN_CALLPATH_UPDATE_ACTION]({ state,commit }, payLoad) {
      if(!state.campaignDetails || !state.campaignDetails.callPaths || state.campaignDetails.callPaths.length == 0)
        throw new Error('Campaign or call path does not exist in the store');
        
      var campaignCallPath = state.campaignDetails.callPaths[0];
      campaignCallPath.StatusID = payLoad.campaignStatusID
      if(campaignCallPath.campaignCallPathId && campaignCallPath.campaignCallPathId > 0){
        campaignCallPath.tazClientAuditLog = payLoad.tazClientAuditLog;
        const response = await campaignService.updateCampaignCallPath(campaignCallPath);      
        commit(CAMPAIGN_CALLPATH_UPDATE_MUTATION, response.data);
      }
      else {
        campaignCallPath.tazClientAuditLog = payLoad.tazClientAuditLog
        const response = await campaignService.createCampaignCallPath(campaignCallPath);
        commit(CAMPAIGN_CALLPATH_UPDATE_MUTATION, response.data);  
      }
    },   

    async [CAMPAIGNS_BY_CALLPATHID_ACTION](state, id) {
      const response = await campaignService.getCampaignsByCallPathID(id);
      return response;
    },
    async [CAMPAIGN_CALLTYPES_LOAD_ACTION]({ commit }) {
      const response = await campaignService.getCampaignCallTypes();
      commit(CAMPAIGN_CALLTYPES_LOAD_MUTATION, response.data);
      return response.data;
    },    
    async [UPDATE_CAMPAIGN_CALLATTRIBUTES_STORE_DATA_ACTION]({ commit, state }, payLoad) {
      if(payLoad.campaignFilters && payLoad.campaignFilters.length > 0) {
        commit(CAMPAIGN_FILTERTYPES_LOAD_MUTATION, payLoad);
        commit(CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_MUTATION, state.channelList)
        commit(CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_MUTATION, state.clientList)
      }
      else{
        var campaignFilterTypeData = [];
        if(state.campaignFilterType && state.campaignFilterType.length == 1 && state.campaignFilterType.some(row=>row.subscriptionFilterTypeID == 0)){
          campaignFilterTypeData = state.campaignFilterType;
          state.campaignFilterType = []
        }
        commit(CAMPAIGN_FILTERTYPES_LOAD_MUTATION, {campaignId: payLoad.campaignId, campaignFilters: campaignFilterTypeData} );
      }
    },
    async [CAMPAIGN_AFFILIATETYPES_LOAD_ACTION]({ commit }) {
      const response = await campaignService.getAffiliateTypes();
      commit(CAMPAIGN_AFFILIATETYPES_LOAD_MUTATION, response.data);
      return response.data;
    }, 
    async [CAMPAIGN_GENERTATE_API_KEY_LOAD_ACTION]({ commit }, payLoad) {
      const response = await campaignService.getCampaignApiKey(payLoad.campaignId, payLoad.displayFormat);
      commit(CAMPAIGN_GENERTATE_API_KEY_LOAD_MUTATION, response.data);      
      return response.data;
    },
    async [CAMPAIGN_DYNAMIC_REQUEST_LOAD_ACTION]({commit}, campaign) {
      commit(CAMPAIGN_DYNAMIC_REQUEST_OLD_DATA_MUTATION, {dynamicNumberRequest: campaign.dynamicNumberRequest, expiryTime: campaign.expiryTime});
      commit(CAMPAIGN_DYNAMIC_REQUEST_CHANGED_MUTATION, campaign.dynamicNumberRequest ? 1 : 0);
      commit(CAMPAIGN_EXPIRY_TIME_CHANGED_MUTATION, campaign.expiryTime);
    },
    async [CAMPAIGN_ENTITIES_LOAD_ACTION]({ commit }) {
      const response = await campaignService.getCampaignEntities();
      commit(CAMPAIGN_ENTITIES_LOAD_MUTATION, response.data);
      return response.data;
  },
  async [CAMPAIGN_NAME_DIDS_LOAD_ACTION]({ commit }) {
    const response = await campaignService.getCampaignNameAndDids();
    commit(CAMPAIGN_NAME_DIDS_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_ACTION]({ commit }) {
    const response = await campaignService.getChannelList();
    commit(CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_ACTION]({ commit }) {
    const response = await campaignService.GetClientList();
    commit(CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_ACTION]({ commit}){
    const response = await campaignService.getSuppressedQuestionMappings();
    commit(CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_MUTATION, response.data);
    return response;   
  },
  async [CAMPAIGN_UPDATE_SUPPRESSED_QUESTION_MAPPINGS_ACTION]({state}, payLoad){
    const response = await campaignService.updateSuppressedQuestionMappings({
      campaignID: payLoad.campaignID, 
      suppressedQuestions: !state.suppressedQuestionData ? null: Object.keys(state.suppressedQuestionData).length === 0 ? null : JSON.stringify(state.suppressedQuestionData), 
      tazClientAuditLog: payLoad.suppressedQuestionMappingsAuditLog})
    return response.data;
  },
  async [CAMPAIGN_LOAD_DROPDOWNS_ACTION]({commit}){
    const response = await campaignService.GetCampaignDropdowns();
    if(response.data.statuses)
      commit(CAMPAIGN_STATUSES_LOAD_MUTATION, response.data.statuses);
    if(response.data.campaignSourceTypes)
      commit(CAMPAIGN_SOURCETYPES_LOAD_MUTATION, response.data.campaignSourceTypes);
    if(response.data.affiliateTypes)
      commit(CAMPAIGN_AFFILIATETYPES_LOAD_MUTATION, response.data.affiliateTypes);
    if(response.data.campaignCallTypes)
      commit(CAMPAIGN_CALLTYPES_LOAD_MUTATION,response.data.campaignCallTypes);  
    if(response.data.campaignCallPaths)
       commit(ALL_CAMPAIGN_CALLPATH_LOAD_MUTATION,response.data.campaignCallPaths);  
    
    return response.data;
  }
}

// mutations
export const mutations = { 
   [CAMPAIGN_CREATE_MUTATION](state, campaign) {
     if(!state.campaignData){
        state.campaignData = [];
        state.campaignData.push(campaign);
      }
      else if(!state.campaignData.some(camp => camp.campaignId === campaign.campaignId)){
         state.campaignData.push(campaign);
      }
      else{
        state.campaignData  = state.campaignData.map((campaignStore) => {
          if (campaignStore.campaignId === campaign.campaignId) {
            return Object.assign({}, campaignStore, campaign);
          }
          return campaignStore;
        });
      }
      state.oldCampaignDetails = JSON.parse(JSON.stringify(campaign)) 
    },
    [CAMPAIGN_UPDATE_MUTATION](state, campaign) {
      state.campaignData  = state.campaignData.map((campaignStore) => {
          if (campaignStore.campaignId === campaign.campaignId) {
            state.oldCampaignDetails = JSON.parse(JSON.stringify(campaign)) 
            return Object.assign({}, campaignStore, campaign);
          }
          return campaignStore;
        });
    },
   [CAMPAIGN_BY_ID_MUTATION](state, campaign) {
      if(campaign.affiliateCampaignSettings && campaign.affiliateCampaignSettings.affiliateCampaignSettingID > 0){
        campaign.affiliateCampaignSettings.margin = (campaign.affiliateCampaignSettings.margin && (campaign.affiliateCampaignSettings.margin % 1) > 0)?campaign.affiliateCampaignSettings.margin.toFixed(2):campaign.affiliateCampaignSettings.margin;
        campaign.affiliateCampaignSettings.minimumPayout = (campaign.affiliateCampaignSettings.minimumPayout && (campaign.affiliateCampaignSettings.minimumPayout % 1) > 0)?campaign.affiliateCampaignSettings.minimumPayout.toFixed(2):campaign.affiliateCampaignSettings.minimumPayout;
        campaign.affiliateCampaignSettings.price = (campaign.affiliateCampaignSettings.price && (campaign.affiliateCampaignSettings.price % 1) > 0)?campaign.affiliateCampaignSettings.price.toFixed(2):campaign.affiliateCampaignSettings.price;
        campaign.affiliateCampaignSettings.marginThresholdInDollar = (campaign.affiliateCampaignSettings.marginThresholdInDollar && (campaign.affiliateCampaignSettings.marginThresholdInDollar % 1) > 0)?campaign.affiliateCampaignSettings.marginThresholdInDollar.toFixed(2):campaign.affiliateCampaignSettings.marginThresholdInDollar;
        campaign.affiliateCampaignSettings.marginThresholdPercentage = (campaign.affiliateCampaignSettings.marginThresholdPercentage && (campaign.affiliateCampaignSettings.marginThresholdPercentage % 1) > 0)?campaign.affiliateCampaignSettings.marginThresholdPercentage.toFixed(2):campaign.affiliateCampaignSettings.marginThresholdPercentage;
        campaign.affiliateCampaignSettings.bid = (campaign.affiliateCampaignSettings.bid && (campaign.affiliateCampaignSettings.bid % 1) > 0)?campaign.affiliateCampaignSettings.bid.toFixed(2):campaign.affiliateCampaignSettings.bid;
        campaign.affiliateCampaignSettings.defaultPrice = (campaign.affiliateCampaignSettings.defaultPrice && (campaign.affiliateCampaignSettings.defaultPrice % 1) > 0)?campaign.affiliateCampaignSettings.defaultPrice.toFixed(2):campaign.affiliateCampaignSettings.defaultPrice;
        campaign.affiliateCampaignSettings.maxBid = (campaign.affiliateCampaignSettings.maxBid && (campaign.affiliateCampaignSettings.maxBid % 1) > 0)?campaign.affiliateCampaignSettings.maxBid.toFixed(2):campaign.affiliateCampaignSettings.maxBid;
        if(campaign.affiliateCampaignSettings.suppressedQuestions){
          state.suppressedQuestionData = JSON.parse(campaign.affiliateCampaignSettings.suppressedQuestions);
        }
        else{
          state.suppressedQuestionData = null;
        }
      }
      state.campaignDetails = campaign;
      state.oldCampaignDetails = JSON.parse(JSON.stringify(state.campaignDetails)); 
      },
    [CAMPAIGNS_LOAD_MUTATION](state, campaign) {
      campaign.map((r) => r.isConcierge = (r.isConcierge) ? 'Yes' : 'No');
      campaign.map((r) => {
        if(r.affiliateCampaignSettings && r.affiliateCampaignSettings.affiliateCampaignSettingID > 0){
         r.AffiliatePrice = r.affiliateCampaignSettings.price && r.affiliateCampaignSettings.price > 0 ? r.affiliateCampaignSettings.price : ''
         r.AffiliatePayableThreshold = r.affiliateCampaignSettings.payableThreshold && r.affiliateCampaignSettings.payableThreshold > 0 ? r.affiliateCampaignSettings.payableThreshold : ''
         }
       });
      Vue.set(state, 'campaignData', [...campaign]);
    },
    [CAMPAIGN_SOURCETYPES_LOAD_MUTATION](state, campaignSourceTypesData) {
      Vue.set(state, 'campaignSourceTypesData', [...campaignSourceTypesData]);
    },       
    [CAMPAIGN_STATUSES_LOAD_MUTATION](state, campaignStatusesData) {
        Vue.set(state, 'campaignStatusesData', [...campaignStatusesData]);
    },
    [CAMPAIGN_ARCHIVE_MUTATION](state, id) {
      var index = this.state.campaigns.campaignData.findIndex((obj => obj.campaignId == id));
      this.state.campaigns.campaignData[index].statusName = "Archive";
      return this.state.campaigns.campaignData;
    },
    [CAMPAIGN_CALLPATHS_LOAD_MUTATION](state, payLoad) {
      if(state.campaignDetails){
        if(state.campaignDetails.campaignId == payLoad.payLoad.campaignId){
          state.campaignDetails.callPaths = [];
          if(payLoad.campaignCallPaths && payLoad.campaignCallPaths.length > 0)
            state.campaignDetails.callPaths = payLoad.campaignCallPaths;
        }
        if(!state.campaignDetails.callPaths || state.campaignDetails.callPaths.length == 0)
          state.campaignDetails.callPaths = [{ callPathId:0,campaignCallPathId:0,pathType:'A',campaignId:payLoad.payLoad.campaignId}]
        if(!state.isCampaignCreateToCallPath)
          state.selectedCampaignCallPath = state.campaignDetails.callPaths;
      }
    },
    [CAMPAIGN_CALLPATH_MODIFIED_MUTATION](state, callPathToBeUpdated) {
      callPathToBeUpdated.campaignCallPath.callPathId = callPathToBeUpdated.callPath.callPathID;
      callPathToBeUpdated.campaignCallPath.callPathStatusID = callPathToBeUpdated.callPath.statusID;
      state.selectedCampaignCallPath = [];
      state.selectedCampaignCallPath.push(callPathToBeUpdated.campaignCallPath);
      if(state.campaignDetails && state.campaignDetails.callPaths && state.campaignDetails.callPaths.length > 0){
        state.campaignDetails.callPaths[0].callPathId = callPathToBeUpdated.callPath.callPathID
        state.campaignDetails.callPaths[0].callPathStatusID = callPathToBeUpdated.callPath.statusID;
      }
    },
    [CAMPAIGN_CALLPATH_UPDATE_MUTATION](state, callPathToBeUpdated) {
      state.oldCampaignCallPaths = [];
      state.oldCampaignCallPaths.push(callPathToBeUpdated);
      if(state.campaignDetails.campaignId == callPathToBeUpdated.campaignId)
          state.campaignDetails.callPaths = [callPathToBeUpdated];
      
      state.selectedCampaignCallPath = state.campaignDetails.callPaths;
    },   
    [CAMPAIGN_STATUS_ACTIVE_MUTATION](state, campaig) { 
      if(state.campaignDetails && state.campaignDetails.campaignId == campaig.campaignId) 
        state.campaignDetails.statusID = 1;
      if(state.campaignData){
        state.campaignData  = state.campaignData.map((campaign) => {
          if (campaign.campaignId == campaig.campaignId) {
            campaig.statusID = 1;
            return Object.assign({}, campaign, campaig);
          }
          else
            return campaign;
        });
      }
    },         
    [CAMPAIGN_CLONE_CHANGE_MUTATION](state, cloneChange) {
      Vue.set(state, 'isClone' , cloneChange);
    },
    [CAMPAIGN_CHECK_CREATE_OR_UPDATE_MUTATION](state, createChange){
      Vue.set(state, 'campaignCreate' , createChange);
    },  
    [CAMPAIGN_CALLTYPES_LOAD_MUTATION](state, campaignCalltypesData) {
      Vue.set(state, 'campaignCalltypesData', [...campaignCalltypesData]);    
    },     
    [CAMPAIGN_FILTERTYPES_LOAD_MUTATION](state, payLoad) {
      if(payLoad.campaignFilters && payLoad.campaignFilters.length > 0){
        var index = 0;
        payLoad.campaignFilters.forEach(element=> {
              element.keyIndex = index;
              element.selectedFilterNameList = [];
              element.isValidFilterType = true
              index = index + 1;
         });
      }
      else
      payLoad.campaignFilters = [getEmptyCallAttribute(payLoad.campaignId)];

      state.campaignFilterType = payLoad.campaignFilters;
      state.oldCampaignFilterType =  JSON.parse(JSON.stringify(state.campaignFilterType));
    },
    [CAMPAIGN_FILTERTYPES_CHANGED_MUTATION](state, payLoad) {      
      payLoad.attributes.subscriptionFilterTypeID = payLoad.subscriptionFilterTypeID;
      payLoad.attributes.filterInput = payLoad.filterInput;      
      payLoad.attributes.campaignFilterTypeInputValue = '';
      payLoad.attributes.filterTypeOperator = null;
      payLoad.attributes.selectedFilterNameList = [];
      payLoad.attributes.isValidFilterType = true;
    },
    [CAMPAIGN_CALLATTRIBUTES_ADD_MUTATION](state, campaignID) { 
      var data = getEmptyCallAttribute(campaignID);
      data.keyIndex = state.campaignFilterType.length + 1; 
      state.campaignFilterType.push(data);
    },
    [CAMPAIGN_CALLATTRIBUTES_REMOVE_MUTATION](state, payLoad) { 
      state.campaignFilterType.splice(payLoad.rowIndex, 1);
      if(state.campaignFilterType.length == 0){
        state.campaignFilterType.push(getEmptyCallAttribute(payLoad.campaignID));
      }
    },
    [CAMPAIGN_CALLATTRIBUTES_FILTERVALUE_CHANGED_MUTATION](state, payLoad) {  
      payLoad.attribute.campaignFilterTypeInputValue = payLoad.filterValue;
    },
    [CAMPAIGN_CALLATTRIBUTES_CLONE_MUTATION](state, payLoad) {
      state.campaignFilterType.map(r =>{ r.campaignFilterID = 0; r.campaignID = payLoad.cloneCampaignID;});
      if(state.campaignDetails && state.campaignDetails.affiliateCampaignSettings)
        state.suppressedQuestionData = JSON.parse(state.campaignDetails.affiliateCampaignSettings.suppressedQuestions);
    },
    [CAMPAIGN_AFFILIATETYPES_LOAD_MUTATION](state, affiliateTypesData) {
      Vue.set(state, 'affiliateTypesData', [...affiliateTypesData]);
    },
    [CAMPAIGN_GENERTATE_API_KEY_LOAD_MUTATION](state, AuthApiKey) {
      Vue.set(state, 'campaignAuthApiKey' , AuthApiKey);
    },
    [CAMPAIGN_DYNAMIC_REQUEST_CHANGED_MUTATION](state, dynamicRequest){
      state.dynamicRequest =  dynamicRequest == 1  ? 1 : 0;
    },
    [CAMPAIGN_EXPIRY_TIME_CHANGED_MUTATION](state, expiryTime){
      state.expiryTime = expiryTime   
    },
    [CAMPAIGN_DYNAMIC_REQUEST_OLD_DATA_MUTATION](state, payLoad){
      state.oldDynamicRequest = payLoad.dynamicNumberRequest;
      state.oldExpiryTime = payLoad.expiryTime;
    },
    [CAMPAIGN_ENTITIES_LOAD_MUTATION](state, campaignEntities) {
      Vue.set(state, 'campaignEntityData', [...campaignEntities]);
  },
  [CAMPAIGN_DETAILS_CLEAR_MUTATION](state){
    state.campaignDetails = null;
    state.oldCampaignFilterType = [];
    state.oldCampaignDetails = [];
    state.oldExpiryTime = null;
    state.oldDynamicRequest = 0;
    state.isSuppressedQuestionsEnabled = false;
    state.oldSuppressedQuestion = null;
  },  
  [CAMPAIGN_OPERATORS_TYPES_CHANGED_MUTATION](state, payLoad) {      
    payLoad.attribute.filterTypeOperator = payLoad.filterTypeOperator;
    payLoad.attribute.campaignFilterTypeInputValue = "";
  },
  [CAMPAIGN_NAME_DIDS_LOAD_MUTATION](state, campaignNameAndDidsData){
    state.campaignNameAndDidsData = campaignNameAndDidsData;
  }, 
  [CAMPAIGN_BID_PRICE_CHANGED_MUTATION](state,payLoad){
    state.campaignStateBidPriceData = [];
    state.campaignStateBidPriceData = payLoad.bidData
  },
  [CAMPAIGN_CREATE_TO_EDIT_MUTATION](state, payLoad){
    state.isCampaignCreateToEdit = payLoad.isCampaignCreateToEdit;
  },
  [CAMPAIGN_TO_CALLPATH_CREATE_MUTATION](state, payLoad){
    state.isCampaignCreateToCallPath = payLoad.isCampaignCreateToCallPath;
    state.assignCallPathCampaignId = payLoad.assignCallPathCampaignId;
  },
  [CAMPAIGN_ASSIGN_CREATED_CALLPATH_DATA_MUTATION](state, payLoad){
    if(state.campaignDetails && state.campaignDetails.campaignId == Number(payLoad.campaignId)){
      if(state.campaignDetails.callPaths && state.campaignDetails.callPaths.length > 0){
        state.campaignDetails.callPaths[0].callPathId = payLoad.newCallPath.callPathID,
        state.campaignDetails.callPaths[0].callPathStatusID = payLoad.newCallPath.statusID,
        state.campaignDetails.callPaths[0].callPathStatusName = payLoad.newCallPath.statusName,
        state.campaignDetails.callPaths[0].updatedBy  = payLoad.newCallPath.createdBy
      }
      state.assignCreatedCallPath = [];
      state.assignCreatedCallPath =  state.campaignDetails.callPaths; 
      state.selectedCampaignCallPath =  state.campaignDetails.callPaths; 
    }
    else{
      if(state.selectedCampaignCallPath && state.selectedCampaignCallPath.length > 0){
        state.selectedCampaignCallPath[0].callPathId = payLoad.newCallPath.callPathID
        state.selectedCampaignCallPath[0].callPathStatusID = payLoad.newCallPath.statusID
      }
    }
  },

  [CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_MUTATION](state, payLoad) {
    payLoad.forEach(element => {
      element.isCheckedChannel = false;
    });
    state.channelList = payLoad;
    //update isChecked true for existing record
    state.campaignFilterType.forEach(c=>{
      var clientQuoteTypeIDs = c.campaignFilterTypeInputValue.split(',');
      state.channelList.forEach(element=>{
          if(clientQuoteTypeIDs.some(x=> x == element.clientQuoteTypeID)){
             if(c.subscriptionFilterTypeID == 40){
                element.isCheckedChannel = true;
                c.selectedFilterNameList.push(element)
             }
            }
        });
    });
    state.oldCampaignFilterType = JSON.parse(JSON.stringify(state.campaignFilterType));
    state.channelList = commonFunctions.methods.sortRecords( state.channelList, 'channelName', true );
  },
  [CAMPAIGN_CALL_ATTRIBUTE_SELECT_CHANNEL_NAME_FILTER_MUTATION](state, payLoad) {
    var index = state.channelList.findIndex(x=> x.clientQuoteTypeID == payLoad.selectedItem.clientQuoteTypeID);
    if(index != -1){
       if(!payLoad.isMultiSelect){ // If filter operator Equal or NotEqual 
          state.channelList.map(c=>{ c.isCheckedChannel = false});
          state.campaignFilterType.filter(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID).map(m=> { m.selectedFilterNameList = []});
       }
      state.channelList[index].isCheckedChannel = true;
      state.campaignFilterType.filter(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID).map(m=> {
         m.selectedFilterNameList.push(state.channelList[index]); });
    }
  },
  [CAMPAIGN_CALL_ATTRIBUTE_REMOVE_CHANNEL_NAME_FILTER_MUTATION](state, payLoad) {
    var index = state.channelList.findIndex(x=> x.clientQuoteTypeID == payLoad.selectedItem.clientQuoteTypeID);
    if(index != -1){
      state.channelList[index].isCheckedChannel = false;
       var campaignFilterIndex = state.campaignFilterType.findIndex(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID);
       if(campaignFilterIndex != -1){
         var data = state.campaignFilterType[campaignFilterIndex].selectedFilterNameList.filter(x=> x.clientQuoteTypeID != payLoad.selectedItem.clientQuoteTypeID);
          state.campaignFilterType[campaignFilterIndex].selectedFilterNameList = data;
       }
    }
  },
  [CAMPAIGN_CALL_ATTRIBUTE_CLEAR_SELECTED_FILTER_NAME_LIST_MUTATION](state, payLoad){
  if(payLoad.filterInput.subscriptionFilterTypeID == 40){
     state.channelList.map(c=>{ c.isCheckedChannel = false});
  }
  if(payLoad.filterInput.subscriptionFilterTypeID == 41){
    state.clientList.map(c=>{ c.isCheckedClient = false});
  }
  state.campaignFilterType.filter(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID).map(m=> { m.selectedFilterNameList = []});
  },
  [CAMPAIGN_CALL_ATTRIBUTE_UPDATE_ISVALID_CAMPAIGN_FILTERTYPE_MUTATION](state, payLoad){
   state.campaignFilterType.map(element=> { element.isValidFilterType = true; });
   if(payLoad && payLoad.filterInput) {
    var filteredCampaignFilterType = state.campaignFilterType.filter(x => x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID)   
    state.campaignFilterType.forEach(element=> {
      if(!element.filterTypeOperator && filteredCampaignFilterType.length > 1) {
        element.isValidFilterType = false;
      }
    });
    }    
  },
  [CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_MUTATION](state, payLoad) {
    payLoad.forEach(element => {
      element.isCheckedClient = false;
      element.accountName = element.accountName.trim();
    });
    state.clientList = payLoad;
    //update isChecked true for existing record
    state.campaignFilterType.forEach(c=>{
      var clientIDs = c.campaignFilterTypeInputValue.split(',');
      state.clientList.forEach(element=>{
          if(clientIDs.some(x=> x == element.clientID)){
             if(c.subscriptionFilterTypeID == 41){
                element.isCheckedClient = true;
                c.selectedFilterNameList.push(element)
             }
            }
        });
    });
    state.oldCampaignFilterType = JSON.parse(JSON.stringify(state.campaignFilterType));
    state.clientList = commonFunctions.methods.sortRecords( state.clientList, 'accountName', true );
  },
  [CAMPAIGN_CALL_ATTRIBUTE_SELECT_CLIENT_NAME_FILTER_MUTATION](state, payLoad) {
    var index = state.clientList.findIndex(x=> x.clientID == payLoad.selectedItem.clientID);
    if(index != -1){
      if(!payLoad.isMultiSelect){ // If filter operator Equal or NotEqual 
          state.clientList.map(c=>{ c.isCheckedClient = false});
          state.campaignFilterType.filter(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID).map(m=> { m.selectedFilterNameList = []});
      }
      state.clientList[index].isCheckedClient = true;
      state.campaignFilterType.filter(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID).map(m=> {
          m.selectedFilterNameList.push(state.clientList[index]); });
    }
  },
  [CAMPAIGN_CALL_ATTRIBUTE_REMOVE_CLIENT_NAME_FILTER_MUTATION](state, payLoad) {
    var index = state.clientList.findIndex(x=> x.clientID == payLoad.selectedItem.clientID);
    if(index != -1){
       state.clientList[index].isCheckedClient = false;
       var campaignFilterIndex = state.campaignFilterType.findIndex(x=> x.keyIndex == payLoad.filterInput.keyIndex && x.subscriptionFilterTypeID == payLoad.filterInput.subscriptionFilterTypeID);
       if(campaignFilterIndex != -1){
         var data = state.campaignFilterType[campaignFilterIndex].selectedFilterNameList.filter(x=> x.clientID != payLoad.selectedItem.clientID);
          state.campaignFilterType[campaignFilterIndex].selectedFilterNameList = data;
       }
    }
  },
  [CAMPAIGN_ASSIGN_CALLPATH_OLD_DATA_MUTATION](state, value){
    state.oldCampaignCallPaths = [];
    state.oldCampaignCallPaths = JSON.parse(JSON.stringify(value));
  },
  [CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_MUTATION](state, suppressedQuestionMappings){
    state.suppressedQuestionMappings = suppressedQuestionMappings
  },
  [CAMPAIGN_SUPPRESSED_QUESTION_CHANGED_MUTATION](state,suppressedQuestionData){
    var tempSuppressedQuestionData = state.suppressedQuestionData ? state.suppressedQuestionData : {}
    if(suppressedQuestionData.checked) {
      if(tempSuppressedQuestionData[suppressedQuestionData.key])
        tempSuppressedQuestionData[suppressedQuestionData.key].push(suppressedQuestionData.suppressedQuestionDetails);
      else
        tempSuppressedQuestionData[suppressedQuestionData.key] = [suppressedQuestionData.suppressedQuestionDetails];
    }else{
      if(tempSuppressedQuestionData[suppressedQuestionData.key] && tempSuppressedQuestionData[suppressedQuestionData.key].length > 0){
        tempSuppressedQuestionData[suppressedQuestionData.key] = tempSuppressedQuestionData[suppressedQuestionData.key].filter(row => row != suppressedQuestionData.suppressedQuestionDetails)
        if(!tempSuppressedQuestionData[suppressedQuestionData.key] || tempSuppressedQuestionData[suppressedQuestionData.key].length == 0){
          delete tempSuppressedQuestionData[suppressedQuestionData.key];
        }
      }
    }
    Vue.set(state, 'suppressedQuestionData', {...tempSuppressedQuestionData});
  },
  [CAMPAIGN_UPDATE_SUPPRESSED_QUESTIONS_MUTATION](state, suppressedQuestion){
    var suppressedQuestionConstantData = appConstants.displaySuppressedQuestionId;
    state.isSuppressedQuestionsEnabled = false;
    state.suppressedQuestionData = suppressedQuestion && suppressedQuestion.suppressedQuestions ? JSON.parse(suppressedQuestion.suppressedQuestions) : null;

   if(suppressedQuestion &&(suppressedQuestion.affiliateTypeID == suppressedQuestionConstantData.PingPostStaticId || 
    suppressedQuestion.affiliateTypeID == suppressedQuestionConstantData.PingPostDynamicId) && suppressedQuestion.pingTransferType == suppressedQuestionConstantData.pingTransferTypeId){
     state.isSuppressedQuestionsEnabled = true;
    }

    state.oldSuppressedQuestion =  state.suppressedQuestionData ? JSON.parse(JSON.stringify(state.suppressedQuestionData)) : null ;
  },
  [ALL_CAMPAIGN_CALLPATH_LOAD_MUTATION](state, campaignCallPaths){
    state.allCampaignCallPaths = campaignCallPaths;
  },
  [CLEAR_ASSIGN_CREATED_CALLPATH_MUTATION](state){
    state.assignCreatedCallPath = [];
  },
}


function getEmptyCallAttribute(campaignID){
  return {
    campaignID: campaignID,
    campaignFilterID: 0,
    campaignFilterTypeInputValue: '',
    subscriptionFilterTypeID: '',
    filterInput: 'Numerical',
    filterTypeOperator: null,        
    selectedFilterNameList: [],
    keyIndex: 0,
    isValidFilterType: true             
  }
}

//getters
export const getters = {
  loadSortedCampaignName(){
    return commonFunctions.methods.sortRecords(state.campaignNameAndDidsData, 'campaignName', true )
  }
}